export default __webpack_public_path__ + "static/media/Safety.5c265e88.png";